import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { alertError, alertSuccess, clearAlert } from '../../store/ducks/alert';

export class ForgotPassword extends React.Component {
  formRef = React.createRef();

  submitEmail = async () => {
    const { dispatch, history } = this.props;
    const userName = this.formRef.current.email.value;

    dispatch(clearAlert());

    try {
      const data = await Auth.forgotPassword(userName);

      dispatch(alertSuccess(`Verification code has been sent to ${data.CodeDeliveryDetails.Destination}`));

      history.push('/resetpassword', { userName });
    } catch (err) {
      dispatch(alertError(err.message || JSON.stringify(err)));
    }
  };

  handleInputsValidation = () => (
    this.formRef.current.reportValidity() !== false
  );

  handleEmailSubmit = (event) => {
    if (event.target.name === 'goButton' || event.key === 'Enter') {
      event.preventDefault();

      if (this.handleInputsValidation()) {
        this.submitEmail();
      }
    }
  };

  render() {
    return (
      <Form ref={this.formRef} onKeyDown={(e) => this.handleEmailSubmit(e)}>
        <Form.Label column={false} />
        <h1 className="text-light">Password Reset</h1>
        <p className="text-dark">
          Enter your&nbsp;
          <strong>email address</strong>
          .&nbsp; We&apos;ll send you an email with your passcode to reset your password.
        </p>
        <InputGroup>
          <Form.Control
            placeholder="Email address"
            aria-label="Email"
            className="border-light bg-light"
            maxLength="40"
            required
            type="email"
            name="email"
          />
          <InputGroup.Append>
            <Button
              onClick={(e) => this.handleEmailSubmit(e)}
              name="goButton"
            >
              Go!
            </Button>
          </InputGroup.Append>
        </InputGroup>
        <br />
      </Form>
    );
  }
}

ForgotPassword.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(connect()(ForgotPassword));
